import { http, onFail, onSuccess } from "./http";

// Countries
export const getCountriesList = () => {
    return http.get('/api/cp/event/access/rule/country/list')
        .then(onSuccess, onFail)
};

export const getCountriesListByType = (eventKey, type) => {
    return http.get(`/api/cp/event/${eventKey}/access/rule/geo/${type}`)
        .then(onSuccess, onFail)
};

export const addCountry = (eventKey, body) => {
    return http.post(`/api/cp/event/${eventKey}/access/rule/geo`, body)
        .then(onSuccess, onFail)
};

export const deleteCountry = (id) => {
    return http.delete(`/api/cp/event/access/rule/geo/${id}`)
        .then(onSuccess, onFail)
};

// IP
export const getIpAddressesList = (eventKey, type) => {
    return http.get(`/api/cp/event/${eventKey}/access/rule/ip/${type}`)
        .then(onSuccess, onFail)
};

export const getIpAddressesListByType = (eventKey, type) => {
    return http.get(`/api/cp/event/${eventKey}/access/rule/ip/${type}`)
        .then(onSuccess, onFail)
};

export const addIpAddress = (eventKey, body) => {
    return http.post(`/api/cp/event/${eventKey}/access/rule/ip`, body)
        .then(onSuccess, onFail)
};

export const deleteIpAddress = (id) => {
    return http.delete(`/api/cp/event/access/rule/ip/${id}`)
        .then(onSuccess, onFail)
};
